// const LINK_FRONT="http://localhost:3000"
// const LINK_BACK="http://localhost:3001"

const LINK_FRONT="https://huellitasapp.netlify.app"
const LINK_BACK="https://huellitas-production-f7c9.up.railway.app"

module.exports = {LINK_BACK, LINK_FRONT};